module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-delete-my-issue-comment-63.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/why-delete-my-issue-comment.md
// module id = 902
// module chunks = 189